module.exports = __webpack_public_path__ + "img/10exp.0f54c8f5.jpg";